import type { Article } from '../@types/ArticleV2';
import { resolveArticlesRoute } from '../routes/utils';

export const getArticleUrl = (article: Article) => {
  return `/${resolveArticlesRoute()}/${article.categories[0].slug}/${article.slug}`;
};
